import React, { useEffect, useState } from 'react';
import { Alert, Button, Select, Switch } from 'antd';
import { fetchPostHeatmap, fetchPostTags } from '@/apis/posts';
import { getRequestErrorMessage } from '@/utils/requestError';
import usePrivateList from '@/utils/usePrivateList';
import { coordinatePair } from '@/utils/coordinates';

export const fetchSelectedHeatmap = async ({ enabled, ...params }) => {
  if (!enabled || !coordinatePair(params.longitude, params.latitude)) return null;
  try { return await fetchPostHeatmap(params); }
  catch (error) { if (error.response?.status === 409) return fetchPostHeatmap(params); throw error; }
};
const NearbyHeatmap = ({ visible, latitude, longitude, radius, onData }) => {
  const [enabled, setEnabled] = useState(false); const [grid, setGrid] = useState('0.01'); const [type, setType] = useState();
  const [tag, setTag] = useState(); const [tags, setTags] = useState([]); const [tagQuery, setTagQuery] = useState(''); const [tagError, setTagError] = useState('');
  useEffect(() => {
    if (!enabled || !visible) return;
    let active = true;
    const timer = setTimeout(() => {
      setTagError('');
      fetchPostTags({ paginate: true, q: tagQuery.trim().slice(0, 30), page: 1, pageSize: 50 }).then(result => { if (active) setTags(result.data || []); })
        .catch(error => { if (active) setTagError(getRequestErrorMessage(error, '标签加载失败，请重新搜索')); });
    }, 300);
    return () => { active = false; clearTimeout(timer); };
  }, [enabled, visible, tagQuery]);
  const { data, loading, error, load } = usePrivateList(fetchSelectedHeatmap, { enabled: enabled && visible, latitude, longitude, radius_km: radius || 5, grid_size: grid, ...(type ? { post_type: type } : {}), ...(tag ? { tag } : {}) }, '热力图加载失败');
  useEffect(() => { onData(!loading && !error && data ? data.data : []); }, [data, loading, error, onData]);
  return <section className="nearby-heatmap-settings"><label className="preference-row">招募热力图 <Switch aria-label="显示招募热力图" checked={enabled} onChange={setEnabled} /></label>
    {enabled && <><p>显示已公开地点的招募密度。每个区域至少有 3 篇帖子才显示；空图不代表附近没有帖子。</p>
      <div className="workspace-filter-grid"><Select aria-label="热力图区域大小" value={grid} onChange={setGrid} options={[{ value: '0.01', label: '小区域' }, { value: '0.05', label: '中区域' }, { value: '0.1', label: '大区域' }]} />
        <Select aria-label="热力图帖子类型" value={type} allowClear placeholder="全部类型" onChange={setType} options={[{ value: 'general', label: '普通帖子' }, { value: 'skill_exchange', label: '技能交换' }]} />
        <Select aria-label="热力图兴趣标签" value={tag} allowClear showSearch filterOption={false} placeholder="全部标签" onSearch={setTagQuery} onChange={setTag} options={tags.map(item => ({ value: item.id, label: item.name }))} />
      </div>
      {tagError && <Alert type="warning" title={tagError} />}
      {loading ? <p role="status">正在加载热力图…</p> : error ? <Alert type="error" title={error} action={<Button onClick={() => load().catch(() => {})}>重试</Button>} /> : data && <p>{data.data.length ? `当前显示 ${data.meta.returned_cells} 个区域，共 ${data.meta.counted_posts} 篇招募帖子` : '暂无达到展示条件的区域，可扩大查询范围或区域大小'}</p>}
    </>}
  </section>;
};
export default NearbyHeatmap;
